module.exports = __webpack_public_path__ + "89919a8d8db0f1ab975f35abfb18b2d5.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/12_column_small_x1/public/history/4.jpg
// module id = 304
// module chunks = 0